// extracted by mini-css-extract-plugin
export default {"imageWrapper":"BO-z","twoColumnImage":"CO-z"};